const grey = {
  25: '#F1F4F9',
  50: '#F1F4F9',
  100: '#F1F4F9',
  // background
  200: '#E2E8F0',
  300: '#CBD5E0',
  400: '#A9B9CC',
  500: '#8496AE',
  // text.disabled
  600: '#68778D',
  // text.secondary
  700: '#4A5568',
  800: '#4A5568',
  900: '#202327' // text.primary
};

export default grey;